import { EditGroupValidationParams } from '../service/GroupEditErrors/ClientGroupEditErrors/ClientGroupEditErrors';

export const OPEN_COMMON_PRICE_EDITOR = 'OPEN_COMMON_PRICE_EDITOR';
export type OPEN_COMMON_PRICE_EDITOR = typeof OPEN_COMMON_PRICE_EDITOR;

export interface OpenCommonPriceEditor {
    type: OPEN_COMMON_PRICE_EDITOR;
}

export const openCommonPriceEditor = (): OpenCommonPriceEditor => {
    return {
        type: OPEN_COMMON_PRICE_EDITOR
    };
};

export const CLOSE_COMMON_PRICE_EDITOR = 'CLOSE_COMMON_PRICE_EDITOR';
export type CLOSE_COMMON_PRICE_EDITOR = typeof CLOSE_COMMON_PRICE_EDITOR;

export interface CloseCommonPriceEditor {
    type: CLOSE_COMMON_PRICE_EDITOR;
}

export const closeCommonPriceEditor = (): CloseCommonPriceEditor => {
    return {
        type: CLOSE_COMMON_PRICE_EDITOR
    };
};

export const CHANGE_COMMON_PRICE_EDITOR = 'CHANGE_COMMON_PRICE_EDITOR';
export type CHANGE_COMMON_PRICE_EDITOR = typeof CHANGE_COMMON_PRICE_EDITOR;

export interface ChangeCommonPriceEditor {
    type: CHANGE_COMMON_PRICE_EDITOR;
    value: number;
    validationParams?: EditGroupValidationParams;
}

export const changeCommonPriceEditor = (
    value: number,
    validationParams: EditGroupValidationParams
): ChangeCommonPriceEditor => {
    return {
        type: CHANGE_COMMON_PRICE_EDITOR,
        value,
        validationParams
    };
};

export const UPDATE_COMMON_PRICE_EDITOR_IS_IN_PROGRESS_DATA = 'UPDATE_COMMON_PRICE_EDITOR_IS_IN_PROGRESS_DATA';
export type UPDATE_COMMON_PRICE_EDITOR_IS_IN_PROGRESS_DATA = typeof UPDATE_COMMON_PRICE_EDITOR_IS_IN_PROGRESS_DATA;

export interface UpdateCommonPriceEditorIsInProgressData {
    type: UPDATE_COMMON_PRICE_EDITOR_IS_IN_PROGRESS_DATA;
    isInProgress: boolean;
}

export const updateCommonPriceEditorIsInProgressData = (
    isInProgress: boolean
): UpdateCommonPriceEditorIsInProgressData => {
    return {
        type: UPDATE_COMMON_PRICE_EDITOR_IS_IN_PROGRESS_DATA,
        isInProgress
    };
};

export type CommonPriceEditorAction =
    | OpenCommonPriceEditor
    | CloseCommonPriceEditor
    | ChangeCommonPriceEditor
    | UpdateCommonPriceEditorIsInProgressData;
